import toDate from '../toDate/index.js'
import addDays from '../addDays/index.js'
import getISODay from '../getISODay/index.js'

/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the ISO week of the new date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the day of the ISO week setted
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
export default function setISODay (dirtyDate, dirtyDay, dirtyOptions) {
  var date = toDate(dirtyDate, dirtyOptions)
  var day = Number(dirtyDay)
  var currentDay = getISODay(date, dirtyOptions)
  var diff = day - currentDay
  return addDays(date, diff, dirtyOptions)
}



//////////////////
// WEBPACK FOOTER
// ../~/date-fns/esm/setISODay/index.js
// module id = 967
// module chunks = 0